import { put, call, takeEvery, takeLatest } from "redux-saga/effects";
import * as apis from "../../network/apis/subCategories";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import { deleteBlob } from "../../utils/blobStorageServices";
import { ConnectingAirportsOutlined } from "@mui/icons-material";

function* subCategoriesListSaga({ payload }) {
  try {
    const response = yield call(apis.subCategoriesList, payload);
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;

    yield put(
      actions.subCategoriesListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.subCategoriesListRequest({
          ...payload,
          page: +response.headers["total-pages"]
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* addSubCategorySaga({ payload }) {
  try {
    const { data, navigate } = payload;
    yield call(apis.addSubCategory, data);
    yield showSuccessMsg("subCategoryAddedSuccessfully");
    yield navigate(ROUTE_PATHS.subCategories);
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
    const { data } = payload;
    yield deleteBlob(data?.AdminCoverImage, "images");
    yield deleteBlob(data?.WebsiteCoverImage, "images");
  }
}

function* editSubCategorySaga({ payload }) {
  try {
    const { data, navigate, id } = payload;
    yield call(apis.editSubCategory, data);
    yield navigate(ROUTE_PATHS.subcategoryDetails.replace(":id", id));
    yield showSuccessMsg("subCategoryEditedSuccessfully");
    const {
      AdminCoverImageBE,
      WebsiteCoverImageBE,
      isAdminImageNew,
      isWebsiteImageNew
    } = data;
    if (isAdminImageNew)
      yield deleteBlob(
        AdminCoverImageBE?.split("/images/")[1],
        "images"
      );
    if (isWebsiteImageNew)
      yield deleteBlob(
        WebsiteCoverImageBE?.split("/images/")[1],
        "images"
      );
  } catch (error) {
    yield error?.response?.data?.Message &&
      showErrorMsg(error.response.data?.Message);
    const {
      data: {
        isAdminImageNew,
        isWebsiteImageNew,
        AdminCoverImage,
        WebsiteCoverImage
      }
    } = payload;
    if (isAdminImageNew) yield deleteBlob(AdminCoverImage, "images");
    if (isWebsiteImageNew)
      yield deleteBlob(WebsiteCoverImage, "images");
  }
}

function* getSubCategoryDetailsSaga({ payload }) {
  try {
    const response = yield call(apis.getSubCategoryDetails, payload);
    yield put(
      actions.getSubCategoryDetailsResponse(response.data.Data)
    );
  } catch (error) {
    yield error?.response?.data?.Message &&
      showErrorMsg(error.response.data?.Message);
  }
}

function* subCategoryProductsListSaga({ payload }) {
  try {
    const response = yield call(
      apis.subCategoryProductsList,
      payload
    );
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.subCategoryProductsListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.subCategoryProductsListRequest({
          ...payload,
          page: +TotalPages
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* deleteSubCategorySaga({ payload }) {
  try {
    yield call(apis.deleteSubCategory, payload);
    yield showSuccessMsg("deleteSubCategorySuccess");
    payload.src === ROUTE_PATHS.subcategoryDetails
      ? yield payload.navigate(ROUTE_PATHS.subCategories)
      : yield put(
          actions.subCategoriesListRequest({
            params: payload.params
          })
        );
  } catch (error) {
    yield error?.response?.data?.Message &&
      showErrorMsg(error.response.data?.Message);
  }
}

export default function* SubCategoriesSagas() {
  yield takeLatest(
    types.SUB_CATEGORIES_LIST_REQUEST,
    subCategoriesListSaga
  );
  yield takeLatest(
    types.ADD_SUB_CATEGORY_REQUEST,
    addSubCategorySaga
  );
  yield takeLatest(
    types.EDIT_SUB_CATEGORY_REQUEST,
    editSubCategorySaga
  );
  yield takeLatest(
    types.GET_SUB_CATEGORY_DETAILS_REQUEST,
    getSubCategoryDetailsSaga
  );
  yield takeLatest(
    types.DELETE_SUB_CATEGORY_REQUEST,
    deleteSubCategorySaga
  );
  yield takeLatest(
    types.SUB_CATEGORY_PRODUCTS_LIST_REQUEST,
    subCategoryProductsListSaga
  );
}
